// Rhyme types offered by the site, mirroring the Android app
// (HomePresenter#getColumnFromMapInOrder): each type maps to one backend
// matchType and an ordered list of result buckets from `typeToResultMap`.
// `headers` marks types whose buckets are shown as separate titled sections.
// `id` is what goes into the shareable URL (?t=...).
export const PROVERB_LANGUAGES = ['de', 'en', 'es', 'fr', 'ru', 'ar'];

const RHYME_TYPES = [
    {
        id: 'double',
        label: 'Double rhyme',
        shortLabel: 'Double',
        matchType: 'vowel_rhyme_consonantal_ending',
        buckets: ['user', 'custom', 'ending2', 'ending1'],
        headers: false,
    },
    {
        id: 'vowel',
        label: 'Vowel rhyme',
        shortLabel: 'Vowel',
        matchType: 'vowel_rhyme',
        buckets: ['custom', 'v'],
        headers: false,
    },
    {
        id: 'classic',
        label: 'Classic rhyme',
        shortLabel: 'Classic',
        matchType: 'classic_rhyme',
        buckets: ['sig3', 'sig2', 'sig1'],
        headers: true,
    },
    {
        id: 'proverb',
        label: 'Proverbs',
        shortLabel: 'Proverbs',
        matchType: 'proverb',
        buckets: ['proverb'],
        headers: false,
        wide: true, // whole lines of lyrics: one per row
        // Only these languages have proverb data in the backend; for every
        // other language `matchType=proverb` always returns an empty list
        // (checked 2026-10-11: store/proverbs/*.prv are empty stubs elsewhere).
        languages: PROVERB_LANGUAGES,
    },
];

export const BUCKET_TITLES = {
    sig3: 'Last 3 syllables match',
    sig2: 'Last 2 syllables match',
    sig1: 'Last syllable matches',
};

export const DEFAULT_RHYME_TYPE = 'double';

export function isRhymeType(id) {
    return RHYME_TYPES.some(type => type.id === id);
}

// A type without a `languages` list works for every language.
export function isRhymeTypeAvailable(id, language) {
    const type = RHYME_TYPES.find(t => t.id === id);
    return Boolean(type) && (!type.languages || type.languages.includes(language));
}

export function rhymeTypesFor(language) {
    return RHYME_TYPES.filter(type => !type.languages || type.languages.includes(language));
}

export function getRhymeType(id) {
    return RHYME_TYPES.find(type => type.id === id) || RHYME_TYPES[0];
}

// Ordered, non-empty sections for a response: [{bucket, title, items}].
export function getSections(typeToResultMap, id) {
    const type = getRhymeType(id);
    return type.buckets
        .map(bucket => ({
            bucket,
            title: type.headers ? BUCKET_TITLES[bucket] : null,
            items: (typeToResultMap[bucket] || []).filter(Boolean),
        }))
        .filter(section => section.items.length > 0);
}

export default RHYME_TYPES;
